import { Language } from '@app/_models/languages/language';

export const DefaultLang: Language = {
    id: 1,
    label: 'Español / Spanish',
    value: 'es',
    iso: 'es_AR',
};
